import { render, staticRenderFns } from "./CallModal.vue?vue&type=template&id=37a0c9fa"
import script from "./CallModal.vue?vue&type=script&lang=js"
export * from "./CallModal.vue?vue&type=script&lang=js"
import style0 from "./CallModal.vue?vue&type=style&index=0&id=37a0c9fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports